import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    overflow: 'hidden !important',
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: '0px',
    left: '0px',
    zIndex: -5,
    backgroundImage: 'linear-gradient(#153E1D, #347F42)',
    '& svg': {
      position: 'absolute',
    },
  },
}));
